import React from 'react';
import { Pricing } from './Pricing';
export function Footer() {
  return <>
      {/* Final CTA Section (Reuses Pricing logic visually) */}
      <div className="bg-brand-dark pt-20 border-t border-gray-800" data-id="element-82">
        <div className="text-center mb-8" data-id="element-83">
          <h2 className="text-4xl md:text-5xl text-white font-display mb-4" data-id="element-84">
            No dejes pasar esta oportunidad
          </h2>
        </div>

        {/* We embed the Pricing component here to avoid duplicating the complex layout */}
        <Pricing data-id="element-85" />
      </div>

      <footer className="bg-brand-black py-12 px-4 border-t border-gray-900 text-center" data-id="element-86">
        <div className="max-w-3xl mx-auto" data-id="element-87">
          <h3 className="text-xl text-white font-bold mb-4" data-id="element-88">
            🔥 PACK HYROX IMPARABLE™
          </h3>
          <p className="text-gray-500 text-sm mb-8 leading-relaxed" data-id="element-89">
            El sistema de entrenamiento número 1 para mujeres que quieren su
            primera carrera HYROX en Argentina. Porque llegar a la línea de
            largada no debería costarte lesiones, abandono ni años de
            improvisación.
          </p>

          <div className="flex flex-col md:flex-row justify-center items-center gap-2 md:gap-4 text-gray-600 text-sm mb-8" data-id="element-90">
            <a href="mailto:contacto@ideahubdigital.online" className="hover:text-brand-pink transition-colors" data-id="element-91">
              contacto@ideahubdigital.online
            </a>
            <span className="hidden md:inline" data-id="element-92">•</span>
            <span className="hover:text-brand-pink transition-colors cursor-pointer" data-id="element-93">
              @ideahubdigital
            </span>
            <span className="hidden md:inline" data-id="element-94">•</span>
            <span className="hover:text-brand-pink transition-colors cursor-pointer" data-id="element-95">
              ideahubdigital.online
            </span>
          </div>

          <p className="text-gray-700 text-xs" data-id="element-96">
            © Idea Hub Digital™ 2025 — Todos los derechos reservados.
          </p>
        </div>
      </footer>
    </>;
}